/// <reference path="../../../Data/DataObjects/DataColumnDialog.ts" />

namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass('Matrix.Data.TableColumnDialog')
    @Serenity.Decorators.responsive()
    export class TableColumnDialog extends Data.DataColumnDialog {

        constructor() {
            super();
            this.form.EditorType.getGridField().hide();
            this.form.FilterOnly.getGridField().hide();
            this.form.GroupOrder.getGridField().hide();
        }
    }
}